var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram",
    transform: "translate(-0.267 -0.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0.267 0.4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "telegram-2",
    "data-name": "telegram",
    d: "M27.929.657A1.842,1.842,0,0,0,26.467,0a2.867,2.867,0,0,0-1.02.2L1.435,9.369C.161,9.855-.011,10.585,0,10.977S.224,12.088,1.524,12.5l.023.007,4.981,1.425,2.694,7.7a2.325,2.325,0,0,0,2.152,1.7,2.546,2.546,0,0,0,1.722-.733l3.081-2.837,4.468,3.6h0l.042.034.012.009A2.579,2.579,0,0,0,22.269,24h0a2.2,2.2,0,0,0,2.1-1.951L28.3,2.622A2.32,2.32,0,0,0,27.929.657ZM8.194,13.663,17.8,8.754,11.82,15.112a.83.83,0,0,0-.2.37l-1.154,4.673Zm3.775,7.72c-.04.037-.08.069-.12.1l1.07-4.335,1.947,1.568Zm14.7-19.09L22.739,21.719c-.038.186-.159.619-.47.619a.969.969,0,0,1-.544-.236l-5.063-4.077,0,0L13.646,15.6,22.3,6.4a.831.831,0,0,0-.983-1.31L7.084,12.364,2.035,10.919l24-9.163a1.219,1.219,0,0,1,.427-.094c.051,0,.141.006.175.047a.793.793,0,0,1,.031.582Zm0,0",
    transform: "translate(6.268 12.4)",
    fill: "#feffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f0f979f2f1d052e792a9c1427c75eabe.svg";
export { ForwardRef as ReactComponent };